import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Card, CardContent, Typography } from "../../../../../components";
import { Skeleton } from "@mui/material";

require("highcharts/modules/accessibility")(Highcharts);

export function DreEvolucaoChart({ rows, colunas = [], loading }) {
  const receitaBruta = rows.find((r) => r.id === "receita-bruta-vendas");
  const faturamento = rows.find((r) => r.id === "faturamento-liquido");
  const lucro = rows.find((r) => r.id === "lucro-liquido");

  const chartOptions = {
    chart: { type: "column", backgroundColor: null, height: 300 },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      categories: colunas,
      crosshair: true,
      labels: { style: { color: "#64748b" } },
    },
    yAxis: {
      title: { text: null },
      labels: {
        formatter: function () {
          const v = this.value;
          if (Math.abs(v) >= 1000) return "R$ " + (v / 1000).toFixed(0) + "k";
          return "R$ " + v;
        },
        style: { color: "#64748b" },
      },
      gridLineColor: "#f1f5f9",
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      symbolRadius: 2,
      itemStyle: { color: "#374151", fontWeight: "500", fontSize: "12px" },
    },
    tooltip: {
      shared: true,
      formatter: function () {
        return this.points.reduce(
          (s, p) =>
            s +
            `<br/><span style="color:${p.color}">●</span> ${
              p.series.name
            }: <b>R$ ${p.y.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}</b>`,
          `<b>${this.x}</b>`,
        );
      },
    },
    plotOptions: {
      column: { borderRadius: 4, pointPadding: 0.1, groupPadding: 0.05 },
    },
    series: [
      {
        name: "Receita",
        type: "column",
        data: receitaBruta?.valoresAgregados ?? Array(colunas.length).fill(0),
        color: "#1e293b",
      },
      {
        name: "Faturamento Líquido",
        type: "line",
        data: faturamento?.valoresAgregados ?? Array(colunas.length).fill(0),
        color: "#2563eb",
        lineWidth: 2,
        marker: {
          radius: 4,
          fillColor: "#fff",
          lineWidth: 2,
          lineColor: "#2563eb",
        },
      },
      {
        name: "Lucro Líquido",
        type: "line",
        data: lucro?.valoresAgregados ?? Array(colunas.length).fill(0),
        color: "#16a34a",
        lineWidth: 2,
        dashStyle: "ShortDash",
        marker: {
          radius: 4,
          fillColor: "#fff",
          lineWidth: 2,
          lineColor: "#16a34a",
        },
      },
    ],
  };

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", mb: 3 }}>
      <CardContent sx={{ p: 2 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: "#64748b", mb: 3 }}
        >
          EVOLUÇÃO — RECEITA, FATURAMENTO E LUCRO
        </Typography>

        {loading ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={300}
            sx={{ borderRadius: 2 }}
          />
        ) : (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        )}
      </CardContent>
    </Card>
  );
}
